import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-social-signin-button',
    imports: [],
    templateUrl: './social-signin-button.component.html'
})
export class SocialSigninButtonComponent {
  @Input() provider: 'google' | 'microsoft' = 'google'
  @Input() label = 'Continue'
  @Output() clicked = new EventEmitter<void>()
}
